// Home.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Home() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const handleSubmit = async () => {
    if (email) {
      try {
        const formData = new FormData();
        formData.append('emailAddress', email);
        
        await fetch('https://docs.google.com/forms/d/e/1FAIpQLSe7LOzrY5c1Nn2skvqjoFqnfA3ov531SJWL8tLQeOD6k83QTg/formResponse', {
          method: 'POST',
          body: formData,
          mode: 'no-cors'
        });
        
        setIsSubmitted(true);
      } catch (error) {
        console.error('Error submitting form:', error);
        setIsSubmitted(true);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="container">
      {/* Subtle animated background grid */}
      <div className="grid-background"></div>
      
      <div className={`content ${animate ? 'animate' : ''}`}>
        {/* Modern logo */}
        <div className="logo">
          <img src={`${process.env.PUBLIC_URL}/discoverly-logo.svg`} alt="Discoverly Logo" className="logo"/>
        </div>

        {/* Main content */}
        <div className="hero-section">
          <h1 className="main-title">
            Discoverly
            <span className="title-dot">.</span>
          </h1>
          
          <p className="subtitle">
            Social Shopping
          </p>
          
          <p className="description">
            Discover, share, and shop with your community.<br/>
            Coming soon to iOS.
          </p>

          {/* Email signup */}
          {!isSubmitted ? (
            <div className="signup-section">
              <div className="input-group">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Enter your email address"
                  className="email-input"
                />
                <button 
                  onClick={handleSubmit} 
                  className="submit-btn"
                  disabled={!email}
                >
                  Get notified
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
              <p className="signup-note">
                Be the first to know when we launch
              </p>
            </div>
          ) : (
            <div className="success-message">
              <div className="success-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                  <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>You're on the list!</h3>
              <p>We'll notify you as soon as Discoverly is available.</p>
            </div>
          )}
        </div>

        {/* Features preview */}
        <div className="features">
          <div className="feature">
            <div className="feature-icon">
              {/* Discover */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2"/>
                <line x1="16" y1="16" x2="21" y2="21" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <span>Discover</span>
          </div>
          <div className="feature">
            <div className="feature-icon">
              {/* Share */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M4 12v-2a4 4 0 014-4h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <polyline points="16 4 20 8 16 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span>Share</span>
          </div>
          <div className="feature">
            <div className="feature-icon">
              {/* Shop */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12H6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M9 7a3 3 0 016 0" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <span>Shop</span>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer">
          <p>© 2025 Discoverly</p>
          <div className="footer-links">
            <Link to="/terms">Terms of Service</Link>
            <span className="footer-divider">•</span>
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer-divider">•</span>
            <Link to="/support">Support</Link>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Home;

